import { Alert, Button, Code, Group, Stack, Text, Title } from '@mantine/core';
import { IconAlertTriangle, IconHome, IconRefresh } from '@tabler/icons-react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';

/**
 * Écran affiché quand un écran plante : message clair en français, le menu reste
 * disponible et l'utilisateur peut recharger ou revenir à l'accueil.
 */
export function RouteErrorPage() {
  const error = useRouteError();
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);

  return (
    <Stack align="flex-start" maw={720}>
      <Title order={2}>Cet écran a rencontré un problème</Title>
      <Alert color="red" icon={<IconAlertTriangle size={18} />} w="100%">
        <Text size="sm">
          L’affichage a été interrompu. Vos données enregistrées ne sont pas touchées. Rechargez
          l’écran ; si le problème revient, transmettez le détail ci-dessous à l’administrateur.
        </Text>
        <Code block mt="sm">
          {detail}
        </Code>
      </Alert>
      <Group>
        <Button leftSection={<IconRefresh size={16} />} onClick={() => window.location.reload()}>
          Recharger l’écran
        </Button>
        <Button variant="default" component={Link} to="/" leftSection={<IconHome size={16} />}>
          Retour à l’accueil
        </Button>
      </Group>
    </Stack>
  );
}
